import { initBrowserAgent } from "~/monitor.client";
import "~/reporter.client";

import { hydrate } from "./entry.client/hydrate";

initBrowserAgent();
hydrate();
